import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "@common/api/apiShared";
import { Result } from "@common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeleteRiskConsequenceDialog } from "./DeleteRiskConsequenceDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

interface DeleteRiskConsequenceResult {
    isDeleted: boolean;
    name: string;
}

export function DeleteRiskConsequenceDialogDataMapping(props: IDeleteRiskConsequenceDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeRiskConsequence = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<DeleteRiskConsequenceResult>) => {
                props.onCloseDialog();

                if (response.value().isDeleted) {
                    props.onDeletion();
                    snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.selectedRiskConsequence.name } }));
                } else {
                    snackbar.show(
                        createElement(Trans, { i18nKey: "riskConsequenceNotDeleted", values: { name: props.selectedRiskConsequence.name } }),
                        "warning"
                    );
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<DeleteRiskConsequenceResult>(`/risk-consequences/${props.selectedRiskConsequence.id}`);
    }

    return {
        removeRiskConsequence,
        inProgress: removeMutation.isLoading,
    };
}
